import { Violet500 } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { PenFillIcon } from '@/icons';
import { AiButton, AiButtonIcon } from './AiButtonBase';
export const AiQueryButton = ({
  onOpenBuildAiModal,
  isFull
}: {
  onOpenBuildAiModal: () => void;
  isFull: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <AiButton icon={<AiButtonIcon icon={<PenFillIcon size={isFull ? 'sm' : 'xs'} fill={Violet500} />} />} label={t('build:ai.queryTab.title')} description={t('build:ai.query.description')} size={isFull ? 'full' : 'simple'} onClick={onOpenBuildAiModal} data-sentry-element="AiButton" data-sentry-component="AiQueryButton" data-sentry-source-file="AiQueryButton.tsx" />;
};